'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlourishColorSwatch = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_style2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FlourishColorSwatch, _React$Component);

  function FlourishColorSwatch() {
    (0, _classCallCheck3.default)(this, FlourishColorSwatch);
    return (0, _possibleConstructorReturn3.default)(this, (FlourishColorSwatch.__proto__ || (0, _getPrototypeOf2.default)(FlourishColorSwatch)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlourishColorSwatch, [{
    key: 'colorName',
    value: function colorName() {
      var t = this.props.t;


      return this.props.name || t('spree.not__available');
    }
  }, {
    key: 'hexToRGB',
    value: function hexToRGB(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

      var hexReplace = function hexReplace(meh, red, green, blue) {
        return red + red + green + green + blue + blue;
      };
      var fullHex = hex.replace(shorthandRegex, hexReplace);

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);

      if (!result) {
        return false;
      }

      return {
        red: parseInt(result[1], 16),
        green: parseInt(result[2], 16),
        blue: parseInt(result[3], 16)
      };
    }

    // https://www.w3.org/TR/AERT#color-contrast

  }, {
    key: 'detectBrightness',
    value: function detectBrightness(rgb) {
      var colorBrightness = (rgb.red * 299 + rgb.green * 587 + rgb.blue * 114) / 1000;

      return Math.round(colorBrightness) > 125 ? 'light' : 'dark';
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      var swatchStyle = {
        backgroundColor: this.props.hexRef
      };

      if (this.props.available && this.props.substrate && this.props.imageUrl) {
        swatchStyle.backgroundImage = 'url(' + this.props.imageUrl + '?im=Resize,width=132,height=132)';
      }

      var theme = this.props.available ? this.detectBrightness(this.hexToRGB(this.props.hexRef)) : t('unavailable');

      return _react2.default.createElement(
        'div',
        { styleName: 'colorSwatch--' + theme },
        _react2.default.createElement('span', { styleName: 'colorSwatch__sample', style: swatchStyle }),
        _react2.default.createElement(
          'span',
          { styleName: 'colorSwatch__label' },
          this.colorName()
        )
      );
    }
  }]);
  return FlourishColorSwatch;
}(_react2.default.Component), _class2.propTypes = {
  imageUrl: _react.PropTypes.string,
  substrate: _react.PropTypes.string,
  hexRef: _react.PropTypes.string,
  name: _react.PropTypes.string,
  available: _react.PropTypes.bool
}, _class2.defaultProps = {
  hexRef: '#ebebeb',
  available: true
}, _temp)) || _class) || _class);
exports.default = FlourishColorSwatch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/ColorSwatch/flourish.js
// module id = 2455
// module chunks = 0